//메인레이아웃
import React, { useReducer } from 'react';

//MUI
import { AppBar, Box, CssBaseline, Toolbar, } from '@mui/material';
import { styled, ThemeProvider } from '@mui/material/styles';
import { theme } from '../../assets/themes';


//COMPONENT
import Header from './MainHeader';
import Sidebar from './MainSidebar';
import { reducer, initialState } from '../../utils/reducer/reducer';

import { useAtom } from 'jotai';
import menuAtom from "../../utils/reducer/menuAtom"

//STYLE
import { makeStyles } from '@material-ui/core/styles';

export const drawerWidth = 200;

const MainContent = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: '10px',
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '300px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '10px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '200px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '10px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: '250px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '10px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));

const MainLayout = (props) => {
    const [ menu, ] = useAtom(menuAtom);
    // 사이드바 open toggle
    const [state, dispatch] = useReducer(reducer, initialState);
    // const leftDrawerOpened = state.opened;
    const leftDrawerOpened = menu.opened;

    const useStyles = makeStyles({
        root: {
          padding:0,
        },
    });
    const classes = useStyles();

    // const handleLeftDrawerToggle = () => {
    //     dispatch({ type: 'SET_MENU', opened: !leftDrawerOpened });
    //     setMenu(item => ({...item, opened: !leftDrawerOpened,  }))//selected: null,
    // };

    return (      
        <ThemeProvider theme={theme}>
        <CssBaseline />   
            <Box sx={{ display: 'flex' }}>     
                {/* header */}
                <AppBar
                    enableColorOnDark
                    position="fixed"
                    color="inherit"
                    elevation={0}
                    sx={{
                        bgcolor: theme.palette.background.layout,
                        padding:0,
                        color: "White",
                        transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
                    }}
                >
                    <Toolbar className={classes.root}>
                        {/* <Header handleLeftDrawerToggle={handleLeftDrawerToggle}/> */}
                        <Header />
                    </Toolbar>
                </AppBar>

                {/* drawer */}
                {/* <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle}/> */}
                <Sidebar drawerOpen={leftDrawerOpened}/> 

                {/* main content */}
                <MainContent theme={theme} open={leftDrawerOpened}>
                    {props.children}
                </MainContent>
            </Box>
        </ThemeProvider>
    );
};

export default MainLayout;
